import { render, staticRenderFns } from "./RitualCircleReader.vue?vue&type=template&id=18cc9c09"
import script from "./RitualCircleReader.vue?vue&type=script&lang=js"
export * from "./RitualCircleReader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18cc9c09')) {
      api.createRecord('18cc9c09', component.options)
    } else {
      api.reload('18cc9c09', component.options)
    }
    module.hot.accept("./RitualCircleReader.vue?vue&type=template&id=18cc9c09", function () {
      api.rerender('18cc9c09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ritualCircles/RitualCircleReader.vue"
export default component.exports